const convertArrayToObject = (keys: any) => {
  const result = {};
  keys.forEach((key: any) => {
    // @ts-ignore
    result[key] = {};
  });
  return result;
};

const groupData = (data: any) => {
  const groupedData = {};
  data.forEach((item: any) => {
    const productId = item.productId;
    const slot = item.slot;
    // @ts-ignore
    if (!groupedData[productId]) {
      // @ts-ignore
      groupedData[productId] = {};
    }
    // @ts-ignore
    if (!groupedData[productId][slot]) {
      // @ts-ignore
      groupedData[productId][slot] = [];
    }
    // @ts-ignore
    groupedData[productId][slot].push(item);
  });

  return groupedData;
};

function generateObject(number: any) {
  const result = {};

  let num = number || 1;
  // console.log(number, num);
  for (let i = 1; i <= num; i++) {
    // @ts-ignore
    result[i] = {};
  }
  return result;
}

export const formattedSlotData = (
  productInfo: any,
  data: any,
  timeArray: any
) => {
  let formattedData = {};
  productInfo.map((product: any) => {
    // @ts-ignore
    formattedData[product._id] = {};
  });

  const convertedObject = convertArrayToObject(timeArray);

  const result = {};
  let groupedData = groupData(data);

  for (const productId in groupedData) {
    // @ts-ignore
    const slots = groupedData[productId];
    let maxSlotLength = 0;
    for (const slot in slots) {
      const slotLength = slots[slot].length;
      if (slotLength > maxSlotLength) {
        maxSlotLength = slotLength;
      }
    }
    // @ts-ignore
    result[productId] = maxSlotLength;
  }

  let cloneFormatData1 = JSON.parse(JSON.stringify(formattedData));
  Object.keys(cloneFormatData1).map((key) => {
    // @ts-ignore
    let count = productInfo.filter((prod) => prod._id === key)[0]
      .aquaAvailableUnit;

    cloneFormatData1[key] = generateObject(
      // @ts-ignore
      Math.max(result[key] || 0, count || 0)
    );
    // @ts-ignore
  });

  let cloneFormatData2 = JSON.parse(JSON.stringify(cloneFormatData1));
  Object.keys(cloneFormatData2).map((key) => {
    // @ts-ignore
    Object.keys(cloneFormatData2[key]).map((typeKey) => {
      // @ts-ignore
      cloneFormatData2[key][typeKey] = convertedObject;
    });
  });

  let cloneFormatData3 = JSON.parse(JSON.stringify(cloneFormatData2));
  let cloneGroupData = JSON.parse(JSON.stringify(groupedData));

  Object.keys(cloneFormatData3).map((key) => {
    // @ts-ignore
    Object.keys(cloneFormatData3[key]).map((typeKey, index) => {
      // @ts-ignore
      Object.keys(cloneFormatData3[key][typeKey]).map((slotKey) => {
        // @ts-ignore
        cloneFormatData3[key][typeKey][slotKey] =
          // @ts-ignore
          cloneGroupData[key]?.[slotKey]?.length > 0
            ? // @ts-ignore
              [cloneGroupData[key][slotKey][index]]
            : [
                {
                  unit: 0,
                  blockedUnit: 0,
                  userType: "",
                  status: "",
                  blockedFor: "available",
                  _id: "",
                  slot: "",
                  aquaDuration: "",
                  qty: 0,
                  date: "",
                  productId: "",
                  checkoutId: "",
                  createdBy: "",
                },
              ];
      });
    });
  });

  // console.log(cloneFormatData3);

  return cloneFormatData3;
};

export const getFormattedAgentList = (data: any, labelName: string) => {
  let formattedAgent = data.map(
    (agent: { _id: string; name: string; type: string }) => {
      let agentObj: { value: string | number; label: string } = {
        value: "",
        label: "",
      };
      agentObj.value = agent._id;
      agentObj.label = agent.name;
      return agentObj;
    }
  );
  formattedAgent.unshift({
    value: "",
    label: labelName,
  });
  return formattedAgent;
};

export const getFormattedReportData = (data: any) => {
  let formattedData = data.map((item: any) => {
    let aquaReportObject = {
      id: "",
      created: "",
      ticket_id: "",
      booked_by: "",
      booked_by_type: "",
      guest_name: "",
      guest_email: "",
      product: [],
      booking_date: "",
      payment_amount: "",
      payment_type: "",
      signature: "",
    };

    aquaReportObject.id = item?._id;
    aquaReportObject.created = item?.createdAt;
    aquaReportObject.ticket_id = item?.ticketNo;
    aquaReportObject.booked_by = item?.user?.name;
    aquaReportObject.booked_by_type = item?.userType;
    aquaReportObject.guest_name = item?.guestDetails?.name;
    aquaReportObject.guest_email = item?.guestDetails?.email;
    aquaReportObject.booking_date = item?.bookingDate;
    aquaReportObject.payment_amount = item?.finalAmount;
    aquaReportObject.payment_type = item?.paymentMethod;
    aquaReportObject.product = item?.items;
    aquaReportObject.signature = item?.customerSign;

    return aquaReportObject;
  });
  return formattedData;
};
